import type { ConjugationSpotlightBlock } from '@ellie/shared';
import { BlockHeader } from '../BlockHeader';

interface Props {
  block: ConjugationSpotlightBlock;
  index: number;
  pageNumber: number;
}

export function ConjugationSpotlightPreview({ block, index, pageNumber }: Props) {
  return (
    <div className="wb-page">
      <BlockHeader block={block} index={index} />

      {/* Verb conjugation tables */}
      <div className="wb-conj-verbs">
        {block.verbs.map((verb, i) => (
          <div key={i} className="wb-conj-verb-card">
            <div className="wb-glossary-verb-header">
              <span className="wb-glossary-infinitive">{verb.infinitive}</span>
              <span className="wb-glossary-translation">&mdash; {verb.translation}</span>
              {verb.isIrregular && <span className="wb-glossary-irregular">irregular</span>}
            </div>
            <div className="wb-conj-tense">{verb.tense}</div>
            <table className="wb-conj-table">
              <tbody>
                <tr>
                  <th>Person</th>
                  <th>Conjugation</th>
                </tr>
                {Object.entries(verb.conjugations).map(([person, form]) => (
                  <tr key={person}>
                    <td>{person}</td>
                    <td>{form}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>

      {/* Fill-in exercises */}
      {block.exercises.length > 0 && (
        <>
          <div className="wb-conj-exercise-header">Practice exercises</div>
          <div className="wb-conj-exercises">
            {block.exercises.map((exercise, i) => (
              <div key={i} className="wb-conj-exercise-item">
                <span className="wb-conj-exercise-verb">{exercise.verb}</span>
                <p className="wb-fill-text">
                  <span className="wb-fill-number">{i + 1}</span>
                  {exercise.sentence.replace(/_{3,}/, '')}
                  <span className="wb-fill-blank" />
                </p>
                <div className="wb-fill-hint">
                  <span className="wb-native-tag">{exercise.hint}</span>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <span className="wb-page-number">{pageNumber}</span>
    </div>
  );
}
